import React from 'react';
import { AlertCircle } from 'lucide-react';

interface SignUpProps {
  onSwitchToSignIn?: () => void;
}

export function SignUp({ onSwitchToSignIn }: SignUpProps) {
  return (
    <div className="mt-8 space-y-6">
      <div className="bg-bw-primary-tint border border-bw-primary/20 rounded-lg p-6 text-center">
        <AlertCircle className="h-12 w-12 text-bw-primary mx-auto mb-4" />
        <h3 className="text-lg font-medium text-blue-900 mb-2">
          Coming Soon!
        </h3>
        <p className="text-bw-primary mb-4">
          We're currently preparing to launch BidWin. New account registration will be available shortly.
        </p>
        <p className="text-sm text-bw-primary">
          Already have an account?{' '}
          <button
            type="button"
            onClick={onSwitchToSignIn}
            className="font-medium text-bw-primary hover:text-bw-accent"
          >
            Sign in here
          </button>
        </p>
      </div>
    </div>
  );
}